import { Component } from '@angular/core';
import { SecondaryPageComponent } from '../../secondary-page/secondary-page.component';

@Component({
  selector: 'app-places',
  standalone: true,
  imports: [],
  templateUrl: './places.component.html',
  styleUrl: './places.component.scss'
})
export class PlacesComponent extends SecondaryPageComponent {

}
